// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { dsn, ignoreErrors, whitelistUrls } from 'config/sentry';
import config from 'config/config';

if (config.environment === 'production') {
  Sentry.init({
    dsn,
    environment: config.environment,
    ignoreErrors,
    whitelistUrls,
  });
}

